// Dependecies
import { useState, useEffect } from 'react';

// Store
import user from '../../store/user';

function usePieCharts(dataTypes) {
  const [userStore] = user();
  const [pieData, useSetPieData] = useState([]);

  useEffect(() => {
    if (userStore.token) {
      useSetPieData(dataTypes);
    }
  }, [userStore.token, dataTypes]);

  return {
    pieData,
  };
}

export default usePieCharts;
